// extracted by mini-css-extract-plugin
export default {"backdrop":"modal_backdrop__2G5hT","modal":"modal_modal__ng7Vx","slide-down":"modal_slide-down__a9ABy"};